module.exports = __webpack_public_path__ + "img/platform-logo-salesforce.271f382e.png";